// Imported from the module, not the domain barrel, so main.tsx does not load the service layer this early.
import { isCredentialRequestId } from "@/shared/domain/tokens/pendingCredentialRequest";

// The credential request approval URLs the backend mints point at the stack root
// (`/credential-requests/<id>`), but a dev stack serves each frontend build under `/<branch>/`.
// CloudFront answers an unknown root path with the index.html of the branch the frontend hosting
// stack was last deployed with through CDK, whose router matches nothing outside its prefix.
// main.tsx forwards the MCP OAuth callback path the same way.
const CREDENTIAL_REQUEST_PREFIX = "/credential-requests/";

/**
 * Return where a root-level link must go on a branch-prefixed dev deployment, or undefined when
 * the location needs no change. Only exact credential request approval paths move, so this
 * cannot redirect anywhere the app did not already link to.
 */
export function branchPrefixedLocation(
  pathname: string,
  search: string,
  branchName: string | undefined,
): string | undefined {
  if (
    !branchName ||
    !pathname.startsWith(CREDENTIAL_REQUEST_PREFIX) ||
    !isCredentialRequestId(pathname.slice(CREDENTIAL_REQUEST_PREFIX.length))
  ) {
    return undefined;
  }
  return `/${branchName}${pathname}${search}`;
}
